import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import useCurrentUser from 'hooks/useCurrentUser'
import MainRoutes from 'routes/MainRoutes'

import PlaceholderPage from 'views/PlaceholderPage'

const AuthorizationController = () => {
  const { t } = useTranslation('common')
  const { currentUser, errors } = useCurrentUser()

  if (errors?.length) {
    return <PlaceholderPage message={errors[0]} />
  }

  if (currentUser) {
    if (!currentUser.roles?.some((x) => ['Content_Express'].includes(x))) {
      return <PlaceholderPage message={t('noAccess')} />
    }

    return <RouterProvider router={createBrowserRouter([MainRoutes])} />
  }

  return <PlaceholderPage message={t('loading')} loading />
}

export default AuthorizationController
